export enum APP_MODE {
  EDIT = "EDIT",
  PUBLISHED = "PUBLISHED",
}

export enum LanguageEnums {
  VI = "vi",
  EN = "en",
  JA = "ja",
}
